import axios from 'axios'
import { axiosHelpers } from './AxiosHelper'
import { snakeCase, camelCase } from 'lodash'
import queryString from 'query-string'
import { useObuGlobalStore } from '@/pinia/ObuGlobalStore'

const isNetworkError = (error) => {
  if (!axios.isAxiosError(error)) {
    return false
  }
  return error.code === 'ERR_NETWORK'
}

const $axios = axiosHelpers(axios)
$axios.interceptors.response.use(
  res => res,
  error => {
    const globalStore = useObuGlobalStore()
    const status = error.response?.status
    if (isNetworkError(error)) {
      globalStore.NetworkFailure(error)
    } else {
      if (status === 401) {
        globalStore.AauthorizedFailure()
      }
      if (status === 403) {
        globalStore.ForbiddenFailure()
      }
      if (status === 404) {
        // globalStore.NotFoundFailure()
      }
      throw error
    }
  }
)

const setData = data => {
  const object = {}
  for (const [key, value] of Object.entries(data)) {
    object[snakeCase(key)] = value
  }
  return object
}

const setQueryString = data => {
  const object = {}
  for (const [key, value] of Object.entries(data)) {
    object[snakeCase(key)] = encodeURI(value)
  }
  return queryString.stringify(object)
}

const getData = data => {
  if (!data.data) return null
  const object = {}
  for (const [key, value] of Object.entries(data.data)) {
    object[camelCase(key)] = value
  }
  return object
}

export { $axios, setQueryString, getData, setData, queryString }
